module.exports = __webpack_public_path__ + "img/icon-activate-line-bot.4ff9c996.svg";